<template>
  <section class="gradeAdd">
    <el-dialog
      :title="id ? '编辑' : '添加'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="60%"
      @close="cancelSubmit"
    >
      <div class="gradeAdd-content">
        <el-form
          ref="info"
          :model="info"
          :rules="rules"
          status-icon
          label-position="left"
          label-width="100px"
        >
          <el-form-item prop="name" label="班级名称：">
            <el-input
              v-model="info.name"
              type="text"
              auto-complete="off"
              placeholder="请输入班级名称"
              clearable
            />
          </el-form-item>
          <el-form-item prop="remark" label="备注：">
            <el-input
              v-model="info.remark"
              auto-complete="off"
              placeholder="请输入备注"
              clearable
              type="textarea"
              :rows="4"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="gradeAdd-foot">
        <el-button @click="cancelSubmit">
          取 消
        </el-button>
        <el-button type="primary" @click="handleSubmit">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import mock from '@/utils/mock'
import api from '@/api/app'
export default {
  name: 'ComGradeAdd',
  components: {},
  props: {
    value: Boolean,
    id: Number,
    rules: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      mineInfo: mock.mine.set.viewInfo,
      mineInit: mock.mine.set.init,
      info: {
        name: null,
        remark: null
      }
    }
  },
  watch: {
    value: {
      handler(val) {
        this.dialogVisible = val
        if (this.id) {
          this.init(val)
        } else {
          this.info = {
            name: null,
            remark: null
          }
        }
      }
    }
  },
  mounted() {},
  methods: {
    async init() {
      if (this.id) {
        const _this = this
        const arr = await _this.mineInit.data4()
        _this.info = arr[arr.findIndex((item) => item.id == _this.id)]
      }
      // this.$forceUpdate()
      this.loading = false
    },
    handleSubmit() {
      this.$refs.info.validate((valid) => {
        if (valid) {
          if (this.info.remark && this.info.name) {
            if (this.id) {
              api.mine.update.grade(this.info).then((res) => {
                this.$message.success('编辑成功')
              })
            } else {
              this.info.id = ''
              api.mine.create.grade(this.info).then((res) => {
                this.$message.success('添加成功')
              })
            }
            this.cancelSubmit()
          } else {
            this.$message({
              message: '请填写完整',
              type: 'error'
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancelSubmit: function() {
      this.info = {
        name: null,
        remark: null
      }
      this.dialogVisible = false
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.gradeAdd {
  &-content {
    height: 100%;
    text-align: center;
  }
}
</style>
